'use client';

import { GalleryVertical, List, Map } from 'lucide-react';
import { useTranslations } from 'next-intl';

import { LucideIcon } from '@/src/components/LucideIcon';
import { FrostedToggleButton, FrostedToggleButtonGroup } from '@/src/components/ui/FrostedToggleButtonGroup';
import { MobileFloatingToggleBar } from '@/src/components/ui/MobileFloatingToggleBar';
import { css } from '@/styled-system/css';
import type { ViewMode } from './SearchViewModeContext';

type Props = {
  value: ViewMode;
  onValueChange: (value: ViewMode) => void;
};

const controlButtonStyles = css.raw({
  flex: '1 1 0',
  minWidth: '2600',
  whiteSpace: 'nowrap',
});

export function MobileSrpBottomControls({ value, onValueChange }: Props) {
  const t = useTranslations('search');

  return (
    <MobileFloatingToggleBar data-testid="mobile-srp-controls" data-srp-component="mobile-srp-controls">
      <FrostedToggleButtonGroup
        aria-label={t('viewMode')}
        value={value}
        onValueChange={(nextValue) => {
          if (typeof nextValue !== 'string') return;
          onValueChange(nextValue as ViewMode);
        }}
        size="sm"
      >
        <FrostedToggleButton
          value="map"
          icon={<LucideIcon icon={Map} />}
          data-testid="mobile-srp-control-map"
          css={controlButtonStyles}
        >
          {t('mobileLabelMap')}
        </FrostedToggleButton>
        <FrostedToggleButton
          value="grid"
          icon={<LucideIcon icon={List} />}
          data-testid="mobile-srp-control-list"
          css={controlButtonStyles}
        >
          {t('viewModeList')}
        </FrostedToggleButton>
        <FrostedToggleButton
          value="feed"
          icon={<LucideIcon icon={GalleryVertical} />}
          data-testid="mobile-srp-control-feed"
          css={controlButtonStyles}
        >
          {t('viewModeFeed')}
        </FrostedToggleButton>
      </FrostedToggleButtonGroup>
    </MobileFloatingToggleBar>
  );
}
